const getKeyValue = (obj = {}) => {
    const result = {};
    for (const i in obj) {
        result.key = i;
        result.value = obj[i];
    }
    return result;
};
export default getKeyValue;